<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wKpNuN/tc-custom/9781418575557.jpg?1701953239669" alt="This image is the cover for the book Divine Nobodies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Divine Nobodies
      </h1>
      <p class="bookDescription body article font2">
        <p>What does a Hip-Hop artist, Waffle House waitress, tire salesman, and disabled girl have to do with discovering spiritual truth? What if embracing authentic Christianity is a journey of unlearning? Welcome to Jim Palmer's world!</p><p>Don Miller meets Anne Lamott meets Brian McLaren in this tale of shedding religion and plunging into uncharted depths of knowing God. Jim Palmer, emergent pastor, shares his compelling off-road spiritual journey and the unsuspecting people who became his guides.</p><p>"Perhaps God's reason for wanting me," writes Palmer, "is much better than my reason for wanting him. Maybe God's idea of my salvation trumps the version I am too willing to settle for. Seeing I needed a little help to get this, God sent a variety pack of characters to awaken me." For all those hoping there's more to God and Christianity than what they've heard or experienced, each chapter of <i>Divine Nobodies</i> gives the reader permission and freedom to discover it for themselves. Sometimes comical, other times tragic, at times shocking, always honest; Jim Palmer's story offers an inspiring and profound glimpse into life with God beyond institutional church and conventional religion. </p><p>"I am tempted to say that Jim Palmer could well be the next Donald Miller, but what they have in common, along with an honest spirituality and extraordinary skill as storytellers, is a unique voice . . . Divine Nobodies is a delight to read, and it was good for my soul to read it." <br/> -BRIAN MCLAREN<br/> Author of <i>The Secret Message of Jesus</i></p><p>"You hold in your hands an amazing story of a broken man finding freedom in all the right places-in God's work in the lives of some extraordinarily ordinary people around him. You will thrill to this delightful blend of gut-wrenching honesty and laugh-out-loud hilarity, and in the end you'll find God much closer, the body of Christ far bigger and your own journey far clearer than you ever dreamed."<br/> -WAYNE JACOBSEN<br/> Author of Authentic Relationships </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Palmer
      </h2>
      
      <p class="authorDescription body article"><P>Jim Palmer is author of widely acclaimed Divine Nobodies and Wide Open Spaces. He encourages the freedom to imagine, dialogue, live, and express new possibilities for being an authentic Christian. With an MDiv from Trinity Divinity School in Chicago, Jim has also worked in pastoral ministry, inner-city, service, and international human rights work. Through writing, speaking, blogging, conversation, and friendship Jim is a unique voice for knowing God beyond organized religion. He and his wife, Pam, and daughter, Jessica, live in Nashville. Jim is a triathlete, enjoys eating pizza, and has a dog named Jack. You can find Jim at divinenobodies.com and on Facebook and Twitter.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2bb497bc